import { render, staticRenderFns } from "./JobAssignmentForm.vue?vue&type=template&id=2e4776d5&scoped=true&"
import script from "./JobAssignmentForm.vue?vue&type=script&lang=js&"
export * from "./JobAssignmentForm.vue?vue&type=script&lang=js&"
import style0 from "./JobAssignmentForm.vue?vue&type=style&index=0&id=2e4776d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4776d5",
  null
  
)

export default component.exports